import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcCameras = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M2.5 5a1 1 0 0 1 1-1h17a1 1 0 1 1 0 2h-17a1 1 0 0 1-1-1Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M21 13c0 5.063-4.03 9-9 9s-9-3.938-9-9V9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4Zm-9 6.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "12",
  cy: "14.5",
  fill: "var(--mds-nav-icon-accent)",
  r: "3"
})), "IcCameras");

export { IcCameras };
//# sourceMappingURL=ic-cameras.js.map
